import React, { useEffect, useRef, useState } from 'react';
import { useData } from '../context/DataContext';
import Section from '../components/Section';
import Loading from '../components/Loading';
import Footer from '../components/Footer';
import './styles/AboutMe.css';
import { Link } from 'react-router-dom';
//import landingVideo from '../assets/videos/landing-video.mp4';
//import bikeVideo from '../assets/videos/bike-video.mp4';
const landingVideo = "https://l5idmko0nslkeu5t.public.blob.vercel-storage.com/landing-video-YL2DmPqd4sA4qgn1a4FWGSWtfvYzdC.mp4";
const bikeVideo = "https://l5idmko0nslkeu5t.public.blob.vercel-storage.com/bike-video-8uLMa8rv8OWUUjrh8Fx8COlG0S3QW0.mp4";

const AboutMe = () => {
  const videoRef = useRef(null);
  const secondVideoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [secondVideoLoaded, setSecondVideoLoaded] = useState(false);
  const contentRef = useRef(null);
  const { data, loading, error } = useData();
  const [showHeader, setShowHeader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHeader(true);
      document.querySelector('.overlay-header')?.classList.add('visible');
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('loadeddata', () => {
        setVideoLoaded(true);
      });

      videoRef.current.addEventListener('error', (e) => {
        console.error('Video error:', e);
        setVideoLoaded(false);
      });
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const skillsSection = document.querySelector('.skills-section');
      const secondVideo = document.querySelector('.second-video-hero');
      const landingVideo = document.querySelector('.video-hero');

      if (skillsSection && secondVideo && landingVideo) {
        const skillsRect = skillsSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        let progress = Math.max(0, Math.min(1, (windowHeight - skillsRect.top) / windowHeight));

        secondVideo.style.opacity = progress;
        landingVideo.style.opacity = 1 - progress;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      setTimeout(() => {
        const sections = contentRef.current.querySelectorAll('.fade-section');
        sections.forEach((section) => {
          if (section.getBoundingClientRect().top < window.innerHeight) {
            section.classList.add('show');
          }
        });
      }, 0);
    }
    window.scrollTo(0, 0);
  }, []);

  if (loading) return <Loading />;
  if (error) return <div>Error loading data</div>;

  const aboutData = data.about || [];
  const sections = {
    header: aboutData.find(row => row[0] === 'Header')?.[1],
    aboutMe: aboutData.find(row => row[0] === 'About Me')?.[1],
    bio: aboutData.find(row => row[0] === 'Bio')?.[1],
    skills: aboutData.find(row => row[0] === 'Skills')?.[1]
  };

  const skillsList = sections.skills
    ?.split('\n')
    .filter(skill => skill.trim())
    .slice(1);

  return (
    <div className="about-container">
      {showHeader && (
        <header className="overlay-header">
          {/* Your delayed header/navbar */}
        </header>
      )}
      <section className="video-hero">
        <video
          ref={videoRef}
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={landingVideo} type="video/mp4" />
          Your browser does not support video playback.
        </video>
      </section>

      <div ref={contentRef} className="content-wrapper">
        <Section content={<><h1>{sections.header}</h1><p className="formatted-section">{sections.aboutMe}</p></>} videoRef={videoRef} />
        <Section content={<p className="formatted-section">{sections.bio}</p>} videoRef={videoRef} sectionClass="bio-section" />
        <Section content={<><h2>Skills</h2><ul className="formatted-section">{skillsList?.map((skill, index) => (<li key={index}>{skill}</li>))}</ul></>} videoRef={videoRef} sectionClass="skills-section" />
      </div>

      <section className="second-video-hero">
        {!secondVideoLoaded && (
          <div className="video-loading">Loading video...</div>
        )}
        <video
          ref={secondVideoRef}
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => setSecondVideoLoaded(true)}
        >
          <source src={bikeVideo} type="video/mp4" />
          Your browser does not support video playback.
        </video>
        <div className="overlay-text">
          Be a part of my journey! <Link to="/contact" style={{ color: '#646cff', textDecoration: 'none', fontWeight: 'bold' }}>Contact me</Link>
        </div>
        <Footer />
      </section>
    </div>
  );
};

export default AboutMe;